// The notification offcanvas fills itself when it opens.
//
// The list is not rendered into the layout of every page: it would be a query and
// a few kilobytes of markup on every request, for a panel most of them never
// open. The layout renders the container empty and this asks for the list at the
// moment the offcanvas is shown — which also means a panel opened twice shows the
// second time what has arrived since, rather than what Unpoly happened to cache.
//
// `cache: false` matters: `notifications#show` marks a notification read over
// GET, and Unpoly would otherwise be free to answer the next list request from
// the copy it took before that.
up.compiler('#notifications-offcanvas', (element) => {
  const load = () => {
    const list = element.querySelector('#notification-list')
    if (!list || !list.dataset.notificationsUrl) return

    up.render({
      target: '#notification-list',
      url: list.dataset.notificationsUrl,
      cache: false,
      history: false,
    }).catch(() => {
      // Rejects when the request fails or the region is gone from the response.
      // Nothing waits on it, and an uncaught rejection would surface as a console
      // error in a scenario that has nothing to do with notifications.
    })
  }

  // Following a notification renders the page behind the offcanvas, which would
  // otherwise stay open over the page it just led to.
  const close = (event) => {
    if (!event.target.closest('a[href]')) return

    window.bootstrap.Offcanvas.getOrCreateInstance(element).hide()
  }

  // A notification arriving while the panel is open would otherwise be missing
  // from the list until it is opened again.
  const reloadIfShown = () => {
    if (element.classList.contains('show')) load()
  }

  element.addEventListener('show.bs.offcanvas', load)
  element.addEventListener('click', close)
  document.addEventListener('notifications:arrived', reloadIfShown)

  return () => {
    element.removeEventListener('show.bs.offcanvas', load)
    element.removeEventListener('click', close)
    document.removeEventListener('notifications:arrived', reloadIfShown)
  }
})
